import types from './types';

export const getPossibleFieldsBatchUpdate = () => ({
  type: types.GAT_POSSIBLE_FIELDS_LIST_BATCH_UPDATE
});

export const setIsContactOverrideMode = (isContactOverrideMode) => ({
  type: types.SET_IS_CONTACT_OVERRIDE_MODE,
  isContactOverrideMode
})

export default {
  getPossibleFieldsBatchUpdate,
  setIsContactOverrideMode
};
